import React from "react";
import Box from "@mui/material/Box";
import { Await, useLoaderData, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

import {
    CMAddressBook,
    GetCampaignDetailsResponse,
    StatsResponse,
} from "services/apiService";
import CampaignForm, { CampaignFormActions } from "./CampaignForm";

const EditCampaign = () => {
    const loaderData = useLoaderData() as {
        data: Promise<[StatsResponse, CMAddressBook[], GetCampaignDetailsResponse]>;
    };

    const { state } = useLocation();
    console.log("\n \t #======> edit campaign loaded : ", state)

    return (
        <React.Suspense
            fallback={
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress />
                    <p>Loading STATS data...</p>
                </Box>
            }
        >
            <Await
                resolve={loaderData.data}
                errorElement={<p>Error while loading STATS data</p>}
            >
                <CampaignForm action={CampaignFormActions.EDIT} state={state} />
            </Await>
        </React.Suspense>
    );
};

export default EditCampaign;